import Papa from "papaparse";

async function getData(filePath:string): Promise<any> {
  return new Promise((resolve, reject) => {
    let path: string = "";
    path = filePath;
    Papa.parse(path, {
      header: true,
      download: true,
      complete:function(results) {
        return resolve(results);
      }
    });
  });
}

export default getData